<template>
    <div>
        <template v-if="policyFromAgreement != undefined">
            <div class="form-title">
                <span class="page-title" id="insurancePolicyHeader" v-if="(insuranceDataFromAgreement != undefined && insuranceDataFromAgreement.policy_id != '' && insuranceDataFromAgreement.policy_id > 0)">Update Insurance Policy</span>
                <span class="page-title" id="insurancePolicyHeader" v-else>Add Insurance Policy</span>
            </div>
        </template>
            <form autocomplete="off" class="form-horizontal basic-form-container metric-form add-user-form-title" id="InsurancePolicyForm">
                <h6 v-if="policy_message" class="color-red">NOTE : {{policy_message}}</h6>
                <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                        <label class="control-label">Is National Lease:</label>
                        <div class="custome-radiobtn">
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="is_national_lease1_item">
                                    Yes
                                    <input type="radio" v-model="is_national_lease" :value="1" id="is_national_lease1_item" name="is_national_lease" v-on:click="isNationalLeaseSelected($event)" :disabled="lockPolicy">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="is_national_lease2_item">
                                    No
                                    <input type="radio" v-model="is_national_lease" :value="0" id="is_national_lease2_item" name="is_national_lease" v-on:click="isNationalLeaseSelected($event)" :disabled="lockPolicy">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label">Self Insured:</label>
                        <div class="custome-radiobtn">
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="self_insured1_item">
                                    Yes
                                    <input type="radio" v-model="self_insured" :value="1" id="self_insured1_item" name="self_insured" v-on:click="selfInsuredSelected($event)" :disabled="lockPolicy">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="boolean optional radio-custom" for="self_insured2_item">
                                    No
                                    <input type="radio" v-model="self_insured" :value="0" id="self_insured2_item" name="self_insured" v-on:click="selfInsuredSelected($event)" :disabled="lockPolicy">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="field-error">{{self_insured_error_msg}}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label require" for="policyown">Policy Ownership:</label>
                        <v-select v-model="policyown" name="policyown" placeholder="Select Policy Ownership."
                                label="text"
                                :options="policyownArr" @change="onPolicySelect($event)">
                        </v-select>
                        <div class="field-error">{{policy_ownership_error_msg}}</div>
                    </div>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                        <label class="control-label require" for="customer_id">Customer:</label>
                        <v-select v-model="customer_id" name="customer_id"
                                label="text" :filterable="false" :options="customerArr"
                                @search="onSearchCustomer"
                                placeholder="Select Customer" class="custom-ci-auto-search" @input="onCustomerSelect($event)" :disabled="disableCustField">
                            <template slot="no-options">
                                Search Customer...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                {{ option.text }}
                                </div>
                            </template>
                        </v-select>
                        <div class="field-error">{{ customer_error_msg }}</div>
                    </div>
                </div>
                <template v-if="selectedSubAccounts.length > 0">
                    <div class="form-row row-cols-md-4 row-cols-1 permission-lists pl-1 pr-3">
                        <div class="permission-inside-list">
                            <template v-for="(mp, index) in selectedSubAccounts">
                                <div class="form-row" :key="index">
                                    <label class="col">{{mp.text}}</label>
                                    <div class="col">
                                        <a href="javascript:void(0)" v-on:click.prevent="removeSelectedCustomer(index,mp)"> <i class="fp-remove color-red"></i> </a>
                                    </div>
                                </div>
                                <p :key="index+'p'">&nbsp;&nbsp;</p>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-if="self_insured == 1">
                    <div class="form-row row-cols-md-4 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label require" for="insurance_agency_id">Self Insured For:</label>
                            <v-select v-model="self_insured_for" name="self_insured_for" placeholder="Select Self Insured For"
                                        label="text"
                                        :options="policyTypesArr" class="close-remove" :disabled="lockPolicy">
                            </v-select>
                            <div class="field-error">{{ self_insured_for_error_msg }}</div>
                        </div>
                        <div class="col form-group">
                            <label class="control-label" for="review_date">Review Date:</label>
                            <div class="input-group">
                                <date-picker placeholder="MM/DD/YYYY" id="review_date" name="review_date" v-model="review_date" :config="optionsDate"></date-picker>
                                <label for="review_date" class="fp-calendar input-calender-icon"></label>
                            </div>
                            <div class="field-error">{{ review_date_error_msg }}</div>
                        </div>
                    </div>
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label" for="documents">Documents (.jpg, .jpeg, .png and .pdf files are allowed)</label>
                            <vue-dropzone
                                id="selfInsuranceDocs"
                                :options="insuredDropzoneOptions"
                                :destroyDropzone=false
                                ref="insuredDropzone"
                                :headers="insuredDropzoneOptions.headers"
                                @vdropzone-complete="afterSelfInsuredComplete"
                                @vdropzone-success="storeSelfInsuredDoc"
                                @vdropzone-removed-file="removeSelfInsuredFile"
                                >
                            </vue-dropzone>
                            <div class="field-error">{{self_insured_doc_error_msg}}</div>
                            <div  v-if="previewSelfInsuredFiles.length > 0">
                                <div class="policy-attachment attachment-list-box">
                                    <label class="control-label" for="attachments">Attachments</label>
                                    <template  v-for="(uFile,fKey) in previewSelfInsuredFiles">
                                        <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                            <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                            <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                            <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                            <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                {{ uFile['display_name'] }}
                                            </a>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                <i class="fp-close color-red"></i>
                                            </button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group">
                            <div class="custom-checkbox">
                                <label for="add_another_policy" class="checkbox-custom">Add Another Policy
                                <input type="checkbox" v-model="add_another_policy" id="add_another_policy" name="add_another_policy" v-on:click="addAnotherPolicy($event)" :disabled="lockPolicy">
                                <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="self_insured == 0 || add_another_policy === true">
                    <div class="form-row row-cols-md-4 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label require" for="policy_type">Policy Type:</label>
                            <v-select v-model="policy_type" name="policy_type" placeholder="Select Policy Type"
                                        label="text"
                                        :options="policyTypesArr" class="close-remove" @input="onPolicyTypeSelect($event)" :disabled="policyTypeLock" >
                            </v-select>
                            <div class="field-error">{{ policy_type_error_msg }}</div>
                        </div>
                        <div class="col form-group">
                            <label class="control-label require" for="policy_number">Policy Number:</label>
                            <input @blur="checkDuplicate" type="text" class="form-control" v-model="policy_number" id="policy_number" placeholder="Enter Policy Number" name="policy_number" :disabled="lockPolicy">
                            <div class="field-error">{{policy_number_error_msg}}</div>
                        </div>
                        <div class="col form-group">
                            <label class="control-label require" for="insurance_company_id">Insurance Company:</label>
                            <a href="javascript:void(0)" v-on:click="addNewCompany('company')" class="pull-right color-blue link-text"> <i class="fp-add" style="font-size:8px;"></i> Add Company</a>
                            <v-select v-model="insurance_company_id" name="insurance_company_id"
                                    label="text" :filterable="false" :options="insuranceCompanyArr"
                                    @search="onSearchInsuranceCompany" @input="checkDuplicate"
                                    placeholder="Select Insurance Company" class="custom-ci-auto-search" :disabled="lockPolicy">
                                <template slot="no-options">
                                    Search Insurance Company...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                    {{ option.text }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                    {{ option.text }}
                                    </div>
                                </template>
                            </v-select>
                            <div class="field-error">{{ insurance_company_error_msg }}</div>
                        </div>
                        <!-- <div class="col form-group">
                            <label class="control-label require" for="policy_number">Policy Number:</label>
                            <input @blur="checkDuplicate" type="text" class="form-control" v-model="policy_number" id="policy_number" placeholder="Enter Policy Number" name="policy_number">
                            <div class="field-error">{{policy_number_error_msg}}</div>
                        </div> -->
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="form-row row-cols-md-3 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="start_date">Start Date:</label>
                                    <div class="input-group">
                                        <date-picker @dp-change="onStartChange" placeholder="MM/DD/YYYY" id="start_date" name="start_date" v-model="start_date" :config="fromOptionsDate" :disabled="lockPolicy"></date-picker>
                                        <label for="start_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ start_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="expiry_date">Expiry Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" @dp-change="onEndChange" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="toOptionsDate" :disabled="lockPolicy"></date-picker>
                                        <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ expiry_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="cancel_date">Cancel Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="cancel_date" name="cancel_date" v-model="cancel_date" :config="optionsDate" :disabled="lockPolicy"></date-picker>
                                        <label for="cancel_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-row row-cols-md-1 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="insurance_agency_id">Insurance Agency:</label>
                                    <a href="javascript:void(0)" v-on:click="addNewCompany('agency')" class="pull-right work-add-asset color-blue link-text"> <i class="fp-add" style="font-size:8px;"></i> Add Agency</a>
                                    <!--<v-select v-model="insurance_agency_id" name="insurance_agency_id" placeholder="Select Insurance Agency"
                                                label="text"
                                                :options="insuranceAgencyArr">
                                    </v-select> -->
                                    <v-select v-model="insurance_agency_id" name="insurance_agency_id"
                                            label="text" :filterable="false" :options="insuranceAgencyArr"
                                            @search="onSearchInsuranceAgency"
                                            placeholder="Select Insurance Agency" class="custom-ci-auto-search close-remove" :disabled="lockPolicy">
                                        <template slot="no-options">
                                            Search Insurance Agency...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                            {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                            {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ insurance_agency_error_msg }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="self_insured == 0 || add_another_policy === true">
                    <template v-if="showInsuranceLimit">
                        <h5 class="color-blue font-bold">Insurance Limit</h5>
                        <div class="form-row row-cols-md-3 row-cols-1">
                            <template v-if="selectedPolicy == 'liability' || selectedPolicy == 'both'">
                                <div class="col form-group">
                                    <label class="control-label require" for="liability">Liability ( Dollars ):</label>
                                    <input type="text" class="form-control text-right" v-model="liability" id="liability" placeholder="Enter Liability" name="liability"
                                                @blur="liability = leaveFocus($event)"
                                                @focus="liability = enterVal($event)"
                                                @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{liability_error_msg}}</div>
                                </div>
                            </template>
                            <!-- <template v-if="selectedPolicy == 'liability' || selectedPolicy == 'both'">
                                <div class="col form-group">
                                    <label class="control-label" for="liability_deductible">Liability Deductible ( Dollars ):</label>
                                    <input type="text" class="form-control" v-model="liabilityDeductible" id="liability_deductible" placeholder="Enter Liability Deductible" name="liability_deductible" @keypress="isNumberCheck($event)">
                                    <div class="field-error">{{liability_deductible_error_msg}}</div>
                                </div>
                            </template> -->
                            <template v-if="selectedPolicy == 'physical' || selectedPolicy == 'both'">
                                <div class="col form-group">
                                    <label class="control-label require" for="comprehensive">Comprehensive ( Dollars ):</label>
                                    <input type="text" class="form-control text-right" v-model="comprehensive" id="comprehensive" placeholder="Enter Comprehensive" name="comprehensive"
                                                @blur="comprehensive = leaveFocus($event)"
                                                @focus="comprehensive = enterVal($event)"
                                                @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{comprehensive_error_msg}}</div>
                                </div>
                            </template>
                            <template v-if="selectedPolicy == 'physical' || selectedPolicy == 'both'">
                                <div class="col form-group">
                                    <label class="control-label require" for="collision">Collision ( Dollars ):</label>
                                    <input type="text" class="form-control text-right" v-model="collision" id="collision" placeholder="Enter Collision" name="collision"
                                                @blur="collision = leaveFocus($event)"
                                                @focus="collision = enterVal($event)"
                                                @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{collision_error_msg}}</div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label require" for="documents">Documents (.jpg, .jpeg, .png and .pdf files are allowed)</label>
                            <vue-dropzone
                                id="insuranceDocs"
                                :options="dropzoneOptions"
                                :destroyDropzone=false
                                ref="dropzone"
                                :headers="dropzoneOptions.headers"
                                @vdropzone-complete="afterComplete"
                                @vdropzone-success="storeDocument"
                                @vdropzone-removed-file="removedSelectedFile"
                                >
                            </vue-dropzone>
                            <div class="field-error">{{insurance_doc_error_msg}}</div>
                            <div  v-if="dropZonePreviewFiles.length > 0">
                                <div class="policy-attachment attachment-list-box">
                                    <label class="control-label" for="attachments">Attachments</label>
                                    <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                        <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                            <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                            <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                            <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                            <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                <!-- {{ uFile['file_name'] }} -->
                                                {{ uFile['display_name'] }}
                                            </a>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                <i class="fp-close"></i>
                                            </button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label">Rental Policy</label>
                            <div class="custome-radiobtn">
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_rental_blanket1_item">
                                        Blanket
                                        <input type="radio" v-model="is_rental_blanket" :value="1" id="is_rental_blanket1_item" name="is_rental_blanket" v-on:click="checkSelected($event)" :disabled="lockPolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_rental_blanket2_item">
                                        Scheduled
                                        <input type="radio" v-model="is_rental_blanket" :value="0" id="is_rental_blanket2_item" name="is_rental_blanket" v-on:click="checkSelected($event)" :disabled="lockPolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_rental_blanket3_item">
                                        Not Applied
                                        <input type="radio" v-model="is_rental_blanket" :value="2" id="is_rental_blanket3_item" name="is_rental_blanket" v-on:click="checkSelected($event)" :disabled="lockPolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label">Lease Policy</label>
                            <div class="custome-radiobtn">
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_lease_blanket1_item">
                                        Blanket
                                        <input type="radio" v-model="is_lease_blanket" :value="1" id="is_lease_blanket1_item" name="is_lease_blanket" v-on:click="checkLeaseSelected($event)" :disabled="lockLeasePolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_lease_blanket2_item">
                                        Scheduled
                                        <input type="radio" v-model="is_lease_blanket" :value="0" id="is_lease_blanket2_item" name="is_lease_blanket" v-on:click="checkLeaseSelected($event)" :disabled="lockLeasePolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="is_lease_blanket3_item">
                                        Not Applied
                                        <input type="radio" v-model="is_lease_blanket" :value="2" id="is_lease_blanket3_item" name="is_lease_blanket" v-on:click="checkLeaseSelected($event)" :disabled="lockLeasePolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row-cols-md-8 row-cols-1">
                        <div class="col form-group" v-if="(is_rental_blanket == 0 || is_lease_blanket == 0) && unitArr.length < 1">
                            <button type="submit" id="addUnit" v-on:click.prevent="addUnit('once')" class="btn btn-primary" >
                                <i class="fp-add"> </i>  Add Unit
                            </button>
                        </div>
                        <div class="col form-group" v-if="(is_rental_blanket == 0 || is_lease_blanket == 0)">
                            <template  v-for="(unit,uKey) in unitArr" >
                                <div v-bind:key="uKey" class="form-row">
                                    <div class="col form-group col-md-2">
                                        <label class="control-label require" for="vehicle_id">Unit:</label>
                                        <v-select v-model="unit.unit_no" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            placeholder="Select Asset" class="custom-ci-auto-search" :disabled="unit.disable_select">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ unit.unit_error_msg }}</div>
                                    </div>
                                    <div class="col form-group col-md-2">
                                        <label class="control-label require">Date Added</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" :id="'date_added'+uKey" name="charge_to_date" v-model="unit.date_added" :config="optionsDate" aria-describedby="basic-addon3" :disabled="unit.disable_select"></date-picker>
                                            <label :for="'date_added'+uKey" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{unit.date_added_error_msg}}</div>
                                    </div>
                                    <div class="col form-group col-md-2">
                                        <label class="control-label require" for="actual_cash_value">Actual Cash Value:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" :for="'actual_cash_value_'+uKey">
                                                    Yes
                                                    <input type="radio" v-model="unit.isACV" :value="1" :checked="unit.isACV == 1" :id="'actual_cash_value_1'+uKey" :name="'is_acv'+uKey" :disabled="lockPolicy && lockLeasePolicy && unit.disable_select">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" :for="'actual_cash_value_'+uKey">
                                                    No
                                                    <input type="radio" v-model="unit.isACV" :value="0" :checked="unit.isACV == 0" :id="'actual_cash_value_'+uKey" :name="'is_acv'+uKey" :disabled="lockPolicy && lockLeasePolicy && unit.disable_select">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error">{{unit.acv_error_msg}}</div>
                                    </div>
                                    <div class="col form-group col-md-2" v-if="unit.isACV == 0">
                                        <label class="control-label require" for="credit_limit">Physical Damage Limit:</label>
                                        <input type="text" class="form-control text-right" v-model="unit.credit_limit" id="credit_limit" placeholder="Enter Credit Limit" name="credit_limit" :disabled="lockPolicy && lockLeasePolicy && unit.disable_select"
                                                    @blur="unit.credit_limit = leaveFocus($event)"
                                                    @focus="unit.credit_limit = enterVal($event)"
                                                    @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{unit.credit_limit_error_msg}}</div>
                                    </div>
                                    <div class="col form-group col-md-2 mt-4">
                                        <template v-if="uKey > 0 || removeSign">
                                            <template v-if="unit.disable_select">
                                                <a href="javascript:void()" class="fp-remove disable-link" v-on:click.prevent="removeLine(uKey,unit.id)" disabled></a>
                                            </template>
                                            <template v-else>
                                                <a href="javascript:void()" class="fp-remove" v-on:click.prevent="removeLine(uKey,unit.id)"></a>
                                            </template>
                                        </template>
                                        <label>&nbsp;&nbsp;</label>
                                        <template>
                                            <a href="javascript:void()" class="fp-plus" v-on:click.prevent="addLine($event,uKey)"></a>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- <div class="col form-group">
                            <label class="control-label" for="comment">Comment:</label>
                            <textarea class="form-control" v-model="comment" name="comment" ref="textarea" id="comment" rows="3" ></textarea>
                        </div>     -->
                    </div>
                    <!-- <div class="form-row row-cols-md-2 row-cols-1" v-if="$route.params.id == undefined">
                        <div class="col form-group" v-if="is_rental_blanket == 1 || (is_rental_blanket == 0 && unitArr.length > 0)">
                            <button type="submit" id="replacePolicyBtn" v-on:click.prevent="fetchReplacePolicy()" class="btn btn-primary" >
                                Append Existing Policy
                            </button>
                        </div>
                        <p>&nbsp;</p>
                        <div class="table-responsive" v-if="replaceInsurancePolicyArr && replaceInsurancePolicyArr.length > 0">
                            <table aria-describedby="table" class="table table-sm table-bordered">
                                <thead>
                                    <tr class="table-primary">
                                        <th style="width:10px;"></th>
                                        <th style="width:60px;">Policy Number</th>
                                        <th>Start Date</th>
                                        <th>Expiry Date</th>
                                        <th>Blanket Policy</th>
                                        <th>Unit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in replaceInsurancePolicyArr" :key="index">
                                        <td scope="col" style="width:10px;">
                                            <input type="checkbox" :id="'selectCheckbox' + index" @input="clickRows($event,row,index)"/>
                                        </td>
                                        <td scope="col" style="width:60px;">{{row.policy_number}}</td>
                                        <td scope="col">{{row.start_date}}</td>
                                        <td scope="col">{{row.expiry_date}}</td>
                                        <td scope="col" v-if="row.is_rental_blanket == 1">Yes</td>
                                        <td scope="col" v-else>No</td>
                                        <td scope="col">{{row.unit}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>     -->
                    <!-- <div class="form-row row-cols-md-4 row-cols-1">

                        <div class="col form-group" v-if="(selectedPolicy == 'both' || selectedPolicy == 'physical')">
                            <label class="control-label require" for="actual_cash_value">Actual Cash Value:</label>
                            <div class="custome-radiobtn">
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="actual_cash_value_1">
                                        Yes
                                        <input type="radio" v-model="isACV" :value="1" id="actual_cash_value_1" name="is_acv" :disabled="lockPolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="boolean optional radio-custom" for="actual_cash_value_2">
                                        No
                                        <input type="radio" v-model="isACV" :value="0" id="actual_cash_value_2" name="is_acv" :disabled="lockPolicy">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="field-error">{{acv_error_msg}}</div>
                        </div>
                        <div class="col form-group" v-if="isACV == 0 && (selectedPolicy == 'both' || selectedPolicy == 'physical')">
                            <label class="control-label require" for="credit_limit">Physical Damage Limit:</label>
                            <input type="text" class="form-control text-right" v-model="credit_limit" id="credit_limit" placeholder="Enter Credit Limit" name="credit_limit" :disabled="lockPolicy"
                                        @blur="credit_limit = leaveFocus($event)"
                                        @focus="credit_limit = enterVal($event)"
                                        @keypress="isAmountCheck($event)">
                            <div class="field-error">{{credit_limit_error_msg}}</div>
                        </div>
                    </div> -->
                    <div class="form-row row-cols-md-2 row-cols-1">
                        <div class="col form-group" v-if="$route.params.id != undefined">
                            <div class="btm-comment-list-section">
                                <h4> All Comments </h4>
                                <div class="comment-list-btm table-responsive-sm">
                                    <template v-if="commentArr && commentArr.length">
                                        <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th>Date</th>
                                                    <th>Comment Type</th>
                                                    <th>Comment</th>
                                                    <th>Comment By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="commentArr && commentArr.length > 0">
                                                    <template v-for="(comment,ind) in commentArr">
                                                        <tr v-bind:key="'recordRow'+ind">
                                                            <td>{{ comment.comment_at }}</td>
                                                            <td>{{comment.comment_type}}</td>
                                                            <td><span v-fp-html="comment.comment"></span></td>
                                                            <td>{{comment.comment_by}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr><td colspan="8" class="no-data-field">No Record Found</td></tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <p class="no-data-field"> No comment available </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="field-error ml-0">{{common_error_msg}}</div>
                <div class="form-group">
                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong id="errorMsg" class="field-error"></strong>
                    </div>
                </div>
                <div class="btn-groups">
                    <button type="button" id="CreateInsurancePolicyBtn" v-if="($route.params.id > 0 && policyFromAgreement == undefined)  || (insuranceDataFromAgreement != undefined && insuranceDataFromAgreement.policy_id != '' && insuranceDataFromAgreement.policy_id > 0)" class="btn btn-primary" v-on:click.prevent="CreateInsurancePolicy" >
                    <i class="fp-reload"> </i>  Update
                    </button>

                    <button type="button" id="CreateInsurancePolicyBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateInsurancePolicy" >
                    <i class="fp-save"> </i>  Save
                    </button>

                    <button type="submit" id="createAndContinueInsurancePolicyBtn" v-if="$route.params.id == undefined && policyFromAgreement == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateInsurancePolicy(flag='Save and Continue')" >
                    <i class="fp-save-continue"> </i>  Save and Continue
                    </button>

                    <button type="submit" v-if="policyFromAgreement != undefined" id="cancelInsurancePolicyBtn" class="btn btn-tertiary" v-on:click.prevent="$parent.createNewPolicy = false" >
                    <i class="fp-close"> </i>  Cancel
                    </button>
                    <button type="submit" v-else id="cancelInsurancePolicyBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                    <i class="fp-close"> </i>  Cancel
                    </button>
                </div>
            </form>
    </div>
</template>
<script>
import Vue from "vue";
import moment from 'moment';
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

//Vue DropZone
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
 
var self;
export default {
  name: "InsurancePolicyForm",
  components: {
    vueDropzone: vue2Dropzone,
    
  },
  mixins:[commonMixins,contractMixins],
  props: {
        policyFromAgreement: {
            type: String,
            required: false,
            default:undefined
        },
        insuranceDataFromAgreement: {
            type: Object,
            required: false,
            default:undefined
        },
    },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    insurance_company_id:null,
    policy_number: "",
    customer_id:null,
    start_date:"",
    expiry_date:"",
    cancel_date:"",
    insurance_agency_id:null,
    insuranceAgencyArr:[],
    customerArr:[],
    insuranceCompanyArr:[],
    loading:false,
    insurance_company_error_msg:"",
    policy_number_error_msg: "",
    customer_error_msg:"",
    start_date_error_msg:"",
    insurance_agency_error_msg:"",
    is_rental_blanket:0,
    liability:"",
    liability_deductible:"",
    liability_deductible_error_msg:"",
    comprehensive:"",
    collision:"",
    files:[],
    liability_error_msg:"",
    comprehensive_error_msg:"",
    collision_error_msg:"",
    dropzoneOptions: {
        url: process.env.ROOT_API +"/store-insurance-docs",
        method: 'POST',
        maxFilesize: 10.00, //MB
        // maxFiles: 1,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        headers: {
            'Accept': 'application/json',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
        dictDefaultMessage: "Drop files here to upload. Files upto maximum 10 MB size are allowed.",
    },
    dropZonePreviewFiles:[],
    unitArr:[],
    loadOnce:false,
    vehicleArr:[],
    assetArr:[],
    idArr:[],
    removeSign:false,
    expiry_date_error_msg:"",
    comment:"",
    self_insured:0,
    showInsuranceLimit:false,
    policy_type:"",
    policy_type_error_msg:"",
    self_insured_for:"",
    self_insured_for_error_msg:"",
    self_insured_error_msg:"",
    policy_ownership_error_msg:"",
    disableCustField:false,
    selectedPolicy:"",
    credit_limit:"",
    credit_limit_error_msg:"",
    acv_error_msg:"",
    approved_by_credit:0,
    showApprovePrompt:false,
    add_another_policy:false,
    selfInsuredDocs:[],
    previewSelfInsuredFiles:[],
    insuredDropzoneOptions: {
        url: process.env.ROOT_API +"/store-insurance-docs",
        method: 'POST',
        maxFilesize: 10.00, //MB
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        headers: {
            'Accept': 'application/json',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
        dictDefaultMessage: "Drop files here to upload. Files upto maximum 10 MB size are allowed.",
    },
    self_insured_doc_error_msg:"",
    validateSelfInsuredDocs:[],
    validateDocs:[],
    insurance_doc_error_msg:"",
    insuranceDocExists:false,
    selfInsuredDocExists:false,
    searchedCompany:'',
    searchedAgency:'',
    commentTypeArr: [],
    commentArr:[],
    urlArr:[],
    isACV:1,
    liabilityDeductible:"",
    subAccountsArr:[],
    selectedSubAccounts:[],
    common_error_msg:"",
    policy_message:"",
    lockPolicy:false,
    policyTypeLock:false,
    lockLeasePolicy:false,
    replaceInsurancePolicyArr:[],
    selectedReplacePolicyArr:[],
    review_date:"",
    review_date_error_msg:"",
    is_national_lease:0,
    noDataFound:"",
    policyId:'',
    is_lease_blanket:1,
    policyown: null,
    policy_number_duplicate:false,
    requestInProgress: false,
    policyownArr: [
        {
            value: "customer",
            text: "Customer"
        },
        {
            value: "own",
            text: "Own"
        },
    ],
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_insurance_policies') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

   },
  created: function() {

  },
  beforeMount() {
    self = this;
  },
  mounted: function() {

        self.getPermissions();
        self.loadFieldData(['policy_comment']);
        var Fullpath = window.location.pathname;
        self.urlArr = Fullpath.split("/");
        setTimeout(function () {
            var path = window.location.pathname;
            self.urlArr = path.split("/");

            if (self.policyFromAgreement != undefined) {

                if (self.insuranceDataFromAgreement != undefined && self.insuranceDataFromAgreement != null) {
                    if (self.insuranceDataFromAgreement.policy_id != undefined && self.insuranceDataFromAgreement.policy_id != ''){
                        self.loadInsurancePolicy(self.insuranceDataFromAgreement.policy_id);
                        self.policyId = self.insuranceDataFromAgreement.policy_id;
                    }
                    if (self.insuranceDataFromAgreement.customer_id != null && self.insuranceDataFromAgreement.customer_id != "") {
                        self.customer_id = {text:self.insuranceDataFromAgreement.customer,value:self.insuranceDataFromAgreement.customer_id,code:self.insuranceDataFromAgreement.customer_code};
                        self.onCustomerSelect('');
                    }
                }
            }else{
                if (self.urlArr[3]) {
                    self.loadInsurancePolicy(self.urlArr[3]);
                    self.loadComments();
                    self.policyId = self.urlArr[3];
                }else{
                    self.noDataFound = false;
                }
            }

        }, 100);

        var path = window.location.href;

        var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data)
            //var asset_type = decodeURIComponent(escape(atob(this.$route.query.asset_type)));

            var url = new URL(path+"?"+decodeStr);
            var custId = url.searchParams.get("customer_id"); // customer id
            var custName = url.searchParams.get("custName");

            self.customer_id = {text:custName,value:custId};
        }

  },
  methods: {

      //check duplicate policy number
    checkDuplicate: function() {
        //console.log(poNo.target.value);
        var id = 0;
        if ( self.urlArr[3]) {
            id = self.urlArr[3];
        }
        if (self.policy_number != null && self.policy_number != "") {
            if (self.insurance_company_id != null && self.insurance_company_id != "") {
                if (self.insurance_company_id.value) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/insurancepolicy/check-duplicate-policy-number",
                        type: "POST",
                        data: {
                            poNo:self.policy_number,
                            id:id,
                            company:self.insurance_company_id.value
                        },
                        dataType: "json",
                        headers: this.ajxHeaders,
                        success: function(data) {
                            self.loading=false;

                            if (data.status == "success" && data.content == "found") {
                                self.policy_number_error_msg = "This policy number already exists."
                                self.policy_number_duplicate = true;
                            } else {
                                self.policy_number_error_msg = ""
                                self.policy_number_duplicate = false;
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading=false;

                            self.generateStatusCodeMessage(jqXHR,true,'delete-insurance-policy')
                        }
                    });
                }
            }
        }
    },
    removedSelectedFile(file, xhr, error) {
        var self = this;
        self.insurance_doc_error_msg = "";

        var policyId = "";
        if (file.xhr != undefined) {
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],policyId,"temp");

            for(var i = 0;i<self.files.length;i++){
                if ( self.files[i].includes(fileName)) {
                    self.files.splice(i,1);
                    self.validateDocs.splice(i,1);
                    self.insuranceDocExists = false;
                }
            }
        }

        console.log(self.files);

    },
    removeServerFile(fileName,key) {

        var self = this;
        var policyId = "";
        var path = window.location.pathname;
        var segments = path.split("/");
        if ( segments[3] != undefined ) {
            policyId = segments[3];
        }

        if (confirm('Are you sure that you want to remove file? ')) {

            self.removeFileFromServer(fileName,policyId,"server");
            self.dropZonePreviewFiles.splice(key,1);

            //remove file from files array
            for ( var i = 0;i<self.files.length;i++ ) {
                if ( self.files[i].includes(fileName)) {
                    self.files.splice(i,1);
                    self.validateDocs.splice(i,1);
                }
            }

            //in case of update and self insured yes
            if (self.self_insured == 1) {
                self.previewSelfInsuredFiles.splice(key,1);
                //remove file from files array
                for ( var i = 0;i<self.selfInsuredDocs.length;i++ ) {
                    if ( self.selfInsuredDocs[i].includes(fileName)) {
                        self.selfInsuredDocs.splice(i,1);
                        self.validateSelfInsuredDocs.splice(i,1);
                    }
                }
            }
        }

    },

    removeAllFiles() {
        var self = this;
        self.$refs.dropzone.removeAllFiles();
    },

    storeDocument(file,response){
        var self = this;
        self.insurance_doc_error_msg = "";
        self.insuranceDocExists = false;
        // var uploadResponse = JSON.parse(response);
        var uploadResponse = response;
        // if (self.$route.params.id > 0 && self.files.length > 0) {
        //     self.insuranceDocExists = true;
        // }
        //push doc path in files array
        self.files.push(uploadResponse.content);
        if (file.type != undefined) {
            var extension = file.type.split("/");
            self.validateDocs.push({
                file_name:file.name,
                size:file.size,
                extension:extension[1]
            });
        }
        /*if (self.insuranceDocExists) {
            self.insurance_doc_error_msg = "Existing File will be removed on Update.";
        }*/

    },
    loadComments:function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        $.ajax({
            url: process.env.ROOT_API + "/policy-comment/fetch/"+segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.commentArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-policy-comment-store')
            }
        });
    },

    afterComplete(file,response){
        var self = this;

    },
    onSearchVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
    },
    checkSelected: function(e) {
          var self = this;
          self.is_rental_blanket = e.target.value;
            if(self.is_lease_blanket != 0 && (self.is_rental_blanket == 1 || self.is_rental_blanket == 2)){
                if (self.unitArr.length > 0) {
                    self.$swal('','Added scheduled unit will be removed on update','warning');
                }
            }
          self.refreshReplacePolicy();
          self.replaceInsurancePolicyArr = [];
          self.selectedReplacePolicyArr = [];
          self.common_error_msg = "";
    },
    onSearchInsuranceCompany(search, loading) {
        var self = this;
        self.searchedCompany = search;
        if (search.length > 2) {
            loading(true);
            self.searchField(loading, search, 'insurance company', '');
        }
    },

    onSearchInsuranceAgency(search, loading) {
        var self = this;
        self.searchedAgency = search;
        if (search.length > 2) {
            loading(true);
            self.searchField(loading, search, 'insurance agency', '');
        }
    },
    addNewCompany:function(from){
        var self = this;

        if (from == 'company'){
            let routeData = this.$router.resolve({name: 'InsuranceCompanyCreate',params:{newCompany: self.searchedCompany}});
            window.open(routeData.href, '_blank');
        }
        if (from == 'agency'){
            let routeData = this.$router.resolve({name: 'InsuranceAgencyCreate',params:{newAgency: self.searchedAgency}});
            window.open(routeData.href, '_blank');
        }
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {
            loading(true);
            if (self.is_national_lease == 1) {
                self.searchField(loading, search, 'customer national lease', '');
            }else{
                self.searchField(loading, search, 'customer', '');
            }
        }
    },
    BackInsurancePolicyList() {
      var self = this;
      self.$router.push("/insurancepolicy/list");
    },

    CreateInsurancePolicy(flag) {
      var self = this;
      var error = false;

      self.insurance_company_error_msg = "";
      self.policy_number_error_msg = "";
      self.customer_error_msg = "";
      self.start_date_error_msg = "";
      self.insurance_agency_error_msg = "";
      self.liability_error_msg = "";
      self.comprehensive_error_msg = "";
      self.collision_error_msg = "";
      self.expiry_date_error_msg = "";
      self.policy_type_error_msg = "";
      self.self_insured_error_msg = "";
      self.policy_ownership_error_msg = "";
      self.credit_limit_error_msg = "";
      self.acv_error_msg = "";
      self.liability_deductible_error_msg = "";
      self.self_insured_for_error_msg = "";
      self.self_insured_doc_error_msg = "";
      self.insurance_doc_error_msg = "";
      self.review_date_error_msg = "";
      self.common_error_msg = "";

      if ( self.policy_number_duplicate === true) {
          console.log("here 1148");
          self.policy_number_error_msg = "This policy number already exists."
          error = true;
      }
      if (self.policyown == "" || !self.policyown) {
        self.policy_ownership_error_msg = "Policy Ownership is Required.";
        error = true;
      }
    //   if (self.customer_id == null || !self.customer_id.value) {
    if (!self.selectedSubAccounts.length) {
        self.customer_error_msg = "Customer is Required.";
        error = true;
      }

      if (self.self_insured == 1) {

        if (self.self_insured_for == "" || !self.self_insured_for.value) {
            self.self_insured_for_error_msg = "Self Insured For is Required.";
            error = true;
        }

        // if (self.selfInsuredDocs.length == 0) {
        //     self.self_insured_doc_error_msg = "Document is Required.";
        //     error = true;
        // }

        if (self.selfInsuredDocs.length > 0) {
            if (self.validateSelfInsuredDocs.length > 0) {
                for (var i = 0;i < self.validateSelfInsuredDocs.length;i++) {
                    let fileObj = self.validateSelfInsuredDocs[i];

                    if (fileObj.extension != undefined) {
                        if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf") {

                        }else{
                            self.self_insured_doc_error_msg = "Only images or PDF files are allowed (.jpg / .jpeg / .png / .pdf).";
                            error = true;
                        }
                    }

                    if (fileObj.size != undefined) {
                        if( fileObj.size > 10000000 ){
                            self.self_insured_doc_error_msg = "File size should not be greater than 10MB.";
                            error = true;
                        }
                    }
                }
            }
        }

      }

      if (self.self_insured == 0 || self.add_another_policy) {

        if (self.insurance_company_id == null || !self.insurance_company_id.value) {
            self.insurance_company_error_msg = "Insurance company is required.";
            error = true;
        }

        if (!self.policy_number || self.policy_number == null || self.policy_number == "") {
            self.policy_number_error_msg = "Policy number is required.";
            error = true;
        }

        /*if (self.customer_id == null || !self.customer_id.value) {
            self.customer_error_msg = "Customer is Required.";
            error = true;
        }*/

        if (!self.start_date || self.start_date == null || self.start_date == "") {
            self.start_date_error_msg = "Start date is required.";
            error = true;
        }

        if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
            self.expiry_date_error_msg = "Expiry Date is required.";
            error = true;
        }

        if (self.insurance_agency_id == null || !self.insurance_agency_id.value) {
            self.insurance_agency_error_msg = "Insurance Agency is required.";
            error = true;
        }

        if (self.policy_type == "" || !self.policy_type.value) {
            self.policy_type_error_msg = "Policy type is required.";
            error = true;
        }

        if (Date.parse(self.start_date) > Date.parse(self.expiry_date)) {
            self.expiry_date_error_msg = "Expiry date should be greater than start date";
            error = true;
        }

        if (self.selectedPolicy != "") {

            // if ( (self.self_insured == 0 && (self.selectedPolicy == "liability" || self.selectedPolicy == "both")) || (self.self_insured == 1 && self.selectedPolicy == "physical") ) {
            if ( self.selectedPolicy == "liability" || self.selectedPolicy == "both" ) {
                if (!self.liability || self.liability == null || self.liability == "" ) {
                    self.liability_error_msg = "Liability is required.";
                    error = true;
                }
                //not required..
                // if (!self.liabilityDeductible || self.liabilityDeductible == null || self.liabilityDeductible == "") {
                //     self.liability_deductible_error_msg = "Liability deductible is Required.";
                //     error = true;
                // }
            }

            // if ( (self.self_insured == 0 && (self.selectedPolicy == "physical" || self.selectedPolicy == "both")) || (self.self_insured == 1 && self.selectedPolicy == "liability")) {
            if ( self.selectedPolicy == "physical" || self.selectedPolicy == "both" ) {

                if (!self.comprehensive || self.comprehensive == null || self.comprehensive == "") {
                    self.comprehensive_error_msg = "Comprehensive is required.";
                    error = true;
                }

                if (!self.collision || self.collision == null || self.collision == "") {
                    self.collision_error_msg = "Collision is required.";
                    error = true;
                }
            }
        }

        if (self.files.length == 0) {
            self.insurance_doc_error_msg = "Document is required.";
            error = true;
        }

        if (self.files.length > 0) {
            if (self.validateDocs.length > 0) {
                for (var i = 0;i < self.validateDocs.length;i++) {
                    let fileObj = self.validateDocs[i];

                    if (fileObj.extension != undefined) {
                        if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf") {

                        }else{
                            self.insurance_doc_error_msg = "Only images or PDF files are allowed (.jpg / .jpeg / .png / .pdf).";
                            error = true;
                        }
                    }

                    if (fileObj.size != undefined) {
                        if(fileObj.size > 10000000){
                            self.insurance_doc_error_msg = "File size should not be greater than 10 MB.";
                            error = true;
                        }
                    }
                }
            }
        }

        if(self.is_rental_blanket == 0 || self.is_lease_blanket == 0){

            if ( !self.unitArr[0] || self.unitArr[0].unit_no == null || !self.unitArr[0].unit_no.value ){

                self.$swal('','Please select the unit for this policy','info');
                return;
            }else{
                self.unitArr[0].unit_error_msg = "";
            }
            if ( !self.unitArr[0] || self.unitArr[0].date_added == '' ){

                self.$swal('','Please select the date added for the unit','info');
                return;
            }else{
                self.unitArr[0].date_added_error_msg = "";
            }


            for ( var i = 0; i < self.unitArr.length; i++ ) {
                if (String(self.unitArr[i].credit_limit).includes(',')){
                    self.unitArr[i].credit_limit = self.unitArr[i].credit_limit.replace(',','');
                }

                if ( self.unitArr[i].unit_no == null || !self.unitArr[i].unit_no.value ) {

                    self.unitArr[i].unit_error_msg = "Unit Required.";
                    error = true;

                }else{
                    self.unitArr[i].unit_error_msg = "";
                }

                if (self.unitArr[i].date_added == null || self.unitArr[i].date_added == "") {

                    self.unitArr[i].date_added_error_msg = "Date added required.";
                    error = true;

                }else{
                    self.unitArr[i].date_added_error_msg = "";
                }

                 if ( self.unitArr[i].isACV == "" && self.unitArr[i].isACV != 0 ) {
                    self.unitArr[i].acv_error_msg = "Please select actual cash value.";
                    error = true;
                }
                if ( self.unitArr[i].isACV == 0 && (self.unitArr[i].credit_limit == "" || self.unitArr[i].credit_limit == "0") ) {
                    self.unitArr[i].credit_limit_error_msg = "Credit limit must be greater than 0.";
                    error = true;
                }

            }
        }


            // if ( self.selectedPolicy == 'both' || self.selectedPolicy == 'physical' ) {

            //     if ( self.isACV == "" && self.isACV != 0 ) {
            //         self.acv_error_msg = "Please select Actual Cash Value.";
            //         error = true;
            //     }
            //     if ( self.isACV == 0 && (self.credit_limit == "" || self.credit_limit == "0") ) {
            //         self.credit_limit_error_msg = "Credit limit must be greater than 0.";
            //         error = true;
            //     }

            // }

        //in case append existing policy
        /*if (self.replaceInsurancePolicyArr.length > 0) {
            if (self.selectedReplacePolicyArr.length > 1) {
                self.common_error_msg = "Please select Single Policy.";
                error = true;
            }
        }*/
      }

      if (!error) {
            if(self.requestInProgress === true){
              return;
            }
            self.requestInProgress = true;
            if (self.$route.params.id > 0) {
                if (self.self_insured == 1) {
                   /* if (self.selfInsuredDocExists) {
                        if (self.selfInsuredDocs.length > 1) {
                            var removeFile = self.selfInsuredDocs[0];
                            self.selfInsuredDocs.splice(0,1);
                            var removeFileName = removeFile.split("/");
                            if (removeFileName[1] != undefined) {
                                self.removeFileFromServer(removeFileName[1],self.$route.params.id,"server");
                            }
                        }
                    }*/
                }

                if (self.self_insured == 0 || self.add_another_policy) {
                    /*if (self.insuranceDocExists) {
                        if (self.files.length > 1) {
                            var removeFile = self.files[0];
                            self.files.splice(0,1);
                            var removeFileName = removeFile.split("/");
                            if (removeFileName[1] != undefined) {
                                self.removeFileFromServer(removeFileName[1],self.$route.params.id,"server");
                            }
                        }
                    }*/
                }

            }
            var path = window.location.pathname;
            var segments = path.split("/");

            if (!segments[3] && (self.comprehensive > 2500 || self.collision > 2500))
            {
                if (confirm('This requires approval from credit team ')) {
                    self.approved_by_credit = 1;
                }else{
                    return;
                }
            }

            self.loading = true;
            if (segments[3])
            {
                $("#CreateInsurancePolicyBtn").val("Updating ...");
                $("#CreateInsurancePolicyBtn").prop("disabled", true);
                $("#cancelInsurancePolicyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueInsurancePolicyBtn").val("Saving ...");
                    $("#CreateInsurancePolicyBtn").prop("disabled", true);
                    $("#createAndContinueInsurancePolicyBtn").prop("disabled", true);
                    $("#cancelInsurancePolicyBtn").prop("disabled",true);

                }else{

                    $("#CreateInsurancePolicyBtn").val("Saving ...");
                    $("#CreateInsurancePolicyBtn").prop("disabled", true);
                    $("#createAndContinueInsurancePolicyBtn").prop("disabled", true);
                    $("#cancelInsurancePolicyBtn").prop("disabled",true);
                }

            }

            var fields = $("#InsurancePolicyForm").serializeArray();
            fields.push({name: "self_insured", value: self.self_insured});
            if (self.self_insured == 1) {
                fields.push({name: "self_insured_for", value: self.self_insured_for.value});
                if(self.selfInsuredDocs.length > 0){
                    fields.push({name: "self_insured_docs", value: JSON.stringify(self.selfInsuredDocs)});
                }else{
                    fields.push({name: "self_insured_docs", value: null});
                }
            }

            if (self.add_another_policy) {
                fields.push({name: "add_another_policy", value:1});
            }else{
                fields.push({name: "add_another_policy", value:0});
            }
            // fields.push({name: "customer_id", value: self.customer_id.value});
            var idArr = []; //insurance policy id array
            // idArr.push(self.customer_id.value);//selected customer id
            for (var i = 0;i < self.selectedSubAccounts.length;i++) {
                idArr.push(self.selectedSubAccounts[i].customer_id);
            }
            fields.push({ name: "sub_accounts", value:JSON.stringify(idArr)});

            if (self.self_insured == 0 || self.add_another_policy) {
                fields.push({name: "insurance_company_id", value: self.insurance_company_id.value});
                fields.push({name: "insurance_agency_id", value: self.insurance_agency_id.value});
                fields.push({name: "is_rental_blanket", value: self.is_rental_blanket});
                fields.push({name:"is_lease_blanket",value:self.is_lease_blanket});
                if(self.files.length > 0){
                    fields.push({name: "doc_path", value: JSON.stringify(self.files)});
                }else{
                    fields.push({name: "doc_path", value: null});
                }
                fields.push({name: "units", value: JSON.stringify(self.unitArr)});
                fields.push({name: "policy_type", value: self.policy_type.value});
                // fields.push({name: "credit_limit", value: self.removeFormat(self.credit_limit)});
                // fields.push({name: "actual_cash_value", value: self.isACV});
                fields.push({name: "approved_by_credit", value: self.approved_by_credit});
                if (self.lockPolicy || self.lockLeasePolicy) {
                    fields.push({name: "policy_number", value: self.policy_number});
                    fields.push({name: "start_date", value: self.start_date});
                    fields.push({name: "expiry_date", value: self.expiry_date});
                    fields.push({name: "cancel_date", value: self.cancel_date});
                }
            }
            fields.push({name: "is_national_lease", value: self.is_national_lease});
            fields.push({name: "collision", value: self.removeFormat(self.collision)});
            fields.push({name: "comprehensive", value: self.removeFormat(self.comprehensive)});
            fields.push({name: "liability", value: self.removeFormat(self.liability)});

            var replaceIdArr = []; //replace insurance policy id array
            for (var i = 0;i < self.selectedReplacePolicyArr.length;i++) {
                replaceIdArr.push(self.selectedReplacePolicyArr[i].id);
            }
            fields.push({ name: "replace_policy", value:JSON.stringify(replaceIdArr)});
            fields.push({name: "id", value: self.policyId});
            fields.push({name: "policyown", value: self.policyown.value});

            $.ajax({
                url: process.env.ROOT_API + "/insurancepolicy/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.requestInProgress = false;
                    if (segments[3])
                    {
                        $("#CreateInsurancePolicyBtn").val("Update");
                        $("#CreateInsurancePolicyBtn").prop("disabled", false);
                        $("#cancelInsurancePolicyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueInsurancePolicyBtn").val("Save and Continue");
                            $("#CreateInsurancePolicyBtn").prop("disabled", false);
                            $("#createAndContinueInsurancePolicyBtn").prop("disabled", false);
                            $("#cancelInsurancePolicyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsurancePolicyBtn").val("Save");
                            $("#CreateInsurancePolicyBtn").prop("disabled", false);
                            $("#createAndContinueInsurancePolicyBtn").prop("disabled", false);
                            $("#cancelInsurancePolicyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {
                        self.policy_number_duplicate = false;

                        if (flag == "Save and Continue") {
                            if (self.self_insured == 1) {
                                self.selfInsuredDocs = [];
                                self.previewSelfInsuredFiles = [];
                                self.validateSelfInsuredDocs = [];
                                self.removeSelfInsuredFiles();
                                self.review_date = "";
                                self.self_insured = 1;
                                self.self_insured_for = "";
                                self.customerInsuredLabel = 0;
                                $("#self_insured1_item").attr("checked",true);
                            }
                            if (self.self_insured == 0 || self.add_another_policy) {
                                self.removeAllFiles();
                                $("#InsurancePolicyForm").trigger("reset");
                                self.insurance_company_id = null;
                                self.policy_number = "";
                                self.start_date = "";
                                self.expiry_date = "";
                                self.cancel_date = "";
                                self.insurance_agency_id = null;
                                self.liability = "";
                                self.comprehensive = "";
                                self.collision = "";
                                self.is_rental_blanket = 0;
                                self.files = [];
                                self.validateDocs = [];
                                self.unitArr = [];
                                self.loadOnce = false;
                                self.self_insured = 0;
                                self.self_insured_for = "";
                                self.policy_type = "";
                                self.showInsuranceLimit = false;
                                // self.credit_limit = "";
                                // self.isACV = 1;
                                self.showApprovePrompt = false;
                                self.comment="";
                                self.refreshReplacePolicy();
                                self.replaceInsurancePolicyArr = [];
                                self.selectedReplacePolicyArr = [];
                                $("#self_insured2_item").attr("checked",true);
                                self.is_lease_blanket = 0;
                            }
                            self.customer_id = null;
                            self.subAccountsArr = [];
                            self.selectedSubAccounts = [];
                            self.common_error_msg = "";
                            self.is_national_lease = 0;
                            $("#is_national_lease2_item").attr("checked",true);

                        } else {
                            if (self.policyFromAgreement != undefined) {
                                self.$parent.fetchInsurancePolicy('');
                                self.$parent.createNewPolicy = false;
                                // self.$parent.notfoundPolicyMessage = 'Policy You Have added is not in agreement criteria please <a href="javascript:void(0)" id="policyNotValid" style="color:blue">click here</a>';
                                self.$parent.attachedInsPol = data.content.id;
                                self.$parent.notfoundPolicyMessage = 'not_valid';
                                // self.$parent.customer_insured = 0;
                            }else{
                                if ( segments[3] ) {
                                    self.$router.push("/insurancepolicy/view/"+segments[3]);
                                } else {
                                    self.$router.push("/insurancepolicy/view/"+data.content.id);
                                }
                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            //alert(1);
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            // setTimeout(function () {
                            //     // $(".alert-warning").removeClass("show");
                            //     // $(".alert-warning").addClass("hide");
                            //     self.common_error_msg = "";
                            // }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.requestInProgress = false;
                    if (segments[3])
                    {
                        $("#CreateInsurancePolicyBtn").val("Update");
                        $("#CreateInsurancePolicyBtn").prop("disabled", false);
                        $("#cancelInsurancePolicyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#InsurancePolicyForm").trigger("reset");


                            $("#createAndContinueInsurancePolicyBtn").val("Save and Continue");
                            $("#CreateInsurancePolicyBtn").prop("disabled", false);
                            $("#createAndContinueInsurancePolicyBtn").prop("disabled", false);
                            $("#cancelInsurancePolicyBtn").prop("disabled",false);

                        }else{

                            $("#CreateInsurancePolicyBtn").val("Save");
                            $("#CreateInsurancePolicyBtn").prop("disabled", false);
                            $("#createAndContinueInsurancePolicyBtn").prop("disabled", false);
                            $("#cancelInsurancePolicyBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-create')
                }
            });

      }else{
          self.errorValidationFocus();
      }

    },

    loadInsurancePolicy(id) {
        var path = window.location.pathname;
        var segments = path.split("/");
        // var polId = self.$route.params.id;
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/insurancepolicy/" + id,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.noDataFound = false;
                    if (data.content.cusCode != "" && data.content.cusCode != null) {
                        // self.customer_id = { text:data.content.cusCode + " | " + data.content.cusName, value:data.content.customer_id};
                        // self.loadSubAccounts(data.content.customer_id,data.content.cusCode);//load sub accounts
                    }
                    if (data.content.sub_accounts != undefined) {
                        if (data.content.sub_accounts.length > 0) {
                            self.selectedSubAccounts = [];
                            var selectedAcc = data.content.sub_accounts;
                            for (var i = 0; i < selectedAcc.length;i++) {
                                self.selectedSubAccounts.push({
                                    policy_id:selectedAcc[i].policy_id,
                                    customer_id:selectedAcc[i].customer_id,
                                    text:selectedAcc[i].text,
                                    disable_select:selectedAcc[i].disable_select,
                                    code:selectedAcc[i].code
                                })
                            }
                            // setTimeout(function(){
                            //     if (self.selectedSubAccounts.length > 0) {
                            //         for (var i = 0; i < self.selectedSubAccounts.length; i++) {
                            //             $("#subAccount" + self.selectedSubAccounts[i].customer_id).prop("checked",true);//select sub accounts
                            //             if (data.content.policy_locked != undefined) {
                            //                 if (data.content.policy_locked == 1) {
                            //                     $("#subAccount" + self.selectedSubAccounts[i].customer_id).prop("disabled",true);
                            //                 }else{
                            //                     $("#subAccount" + self.selectedSubAccounts[i].customer_id).prop("disabled",false);
                            //                 }
                            //             }else{
                            //                 $("#subAccount" + self.selectedSubAccounts[i].customer_id).prop("disabled",false);
                            //             }
                            //         }
                            //     }
                            // },1000);
                        }
                    }
                    self.is_national_lease = data.content.is_national_lease;
                    if(data.content.policy_owner == null) {
                        self.policyown = null;
                    } else {
                        self.policyown = {value: data.content.policy_owner, text: self.titleCase(data.content.policy_owner)};
                    }
                    if (data.content.self_insured != null) {
                        //self insured is Yes
                        self.self_insured = 1;
                        self.self_insured_for = {text:self.titleCase(data.content.self_insured),value:data.content.self_insured};
                        if(data.content.doc_path != null) {
                            self.previewSelfInsuredFiles = data.content.doc_path;
                        }
                        if (data.content.review_date != null) {
                            self.review_date = data.content.review_date;
                        }
                        self.loadSelfInsuredFiles();
                    }else{
                        //self insured is No
                        self.self_insured = 0;

                        self.insurance_company_id = { text:data.content.icCode + " | " + data.content.icName, value:data.content.insurance_company_id};
                        self.policy_number = data.content.policy_number;
                        self.start_date = data.content.start_date;
                        self.expiry_date = data.content.expiry_date;

                        // set min and max date for start and end date as some time its not called...
                        if ( self.expiry_date != "" && self.expiry_date != null ) {
                            self.$set(self.fromOptionsDate, 'maxDate', moment(self.expiry_date,"MM/DD/YYYY"));
                        }
                        self.$set(self.toOptionsDate, 'minDate', moment(self.start_date,"MM/DD/YYYY"));

                        self.cancel_date = data.content.cancel_date;
                        if(data.content.iaName != null){
                            var agencyText = "";
                            if (data.content.iaCode != null) {
                                agencyText = data.content.iaCode + " | " + data.content.iaName;
                            }else{
                                agencyText = data.content.iaName;
                            }
                            if (data.content.address_line_1 != null && data.content.address_line_1 != "") {
                                agencyText += " | ";
                                agencyText += data.content.address_line_1;
                            }
                            if (data.content.agency_city != null && data.content.agency_city != "") {
                                agencyText += " | ";
                                agencyText += data.content.agency_city;
                            }
                            self.insurance_agency_id = { text:agencyText, value:data.content.insurance_agency_id};
                        }else{
                            self.insurance_agency_id = null;
                        }
                        self.liability = data.content.liability;
                        self.comprehensive = data.content.comprehensive;
                        self.collision = data.content.collision;
                        // self.liabilityDeductible = data.content.liability_deductible;
                        self.is_rental_blanket = data.content.is_rental_blanket;
                        self.is_lease_blanket = data.content.is_lease_blanket;
                        if(data.content.doc_path != null) {
                            self.dropZonePreviewFiles = data.content.doc_path;

                        }
                        if(data.content.mapper_data && data.content.mapper_data.length > 0){

                            self.unitArr = data.content.mapper_data;

                            if ( self.unitArr != undefined && self.unitArr.length > 0 ) {

                                self.removeSign = true;
                            }
                        }else{

                            self.unitArr = [];
                        }
                        self.comment = data.content.comment;
                        self.policy_type = {text:self.titleCase(data.content.policy_type),value:data.content.policy_type};
                        self.selectedPolicy = data.content.policy_type;
                        if(data.content.policy_type == 'both' && data.content.policy_locked == 1){
                            self.policyTypeLock = true;
                        }
                            // self.credit_limit = data.content.credit_limit;
                            // self.isACV = data.content.actual_cash_value;
                        self.approved_by_credit = data.content.approved_by_credit;
                        if (data.content.approved_by_credit == 1) {
                            self.showApprovePrompt = true;
                        }
                        self.showInsuranceLimit = true;

                        self.loadFilesPreview();
                    }
                    if (data.content.policy_message != undefined) {
                        self.policy_message = data.content.policy_message;
                    }
                    if (data.content.policy_locked != undefined) {
                        if (data.content.policy_locked == 1) {
                            self.lockPolicy = true;
                        }else{
                            self.lockPolicy = false;
                        }
                    }
                    if (data.content.lease_policy_locked != undefined) {
                        if (data.content.lease_policy_locked == 1) {
                            self.lockLeasePolicy = true;
                        }else{
                            self.lockLeasePolicy = false;
                        }
                    }
                }else{
                    if (data.code == 201) {
                        self.noDataFound = true;
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'create-insurance-policy-load')
            }
        });
    },
    isNumberCheck: function(evt) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    //load files in drop zone
    loadFilesPreview:function() {
        var self = this;
        if ( self.dropZonePreviewFiles.length > 0 ) {

            for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {

                var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                var url = self.dropZonePreviewFiles[i].url;
                //get file path from url
                self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                //self.$refs.dropzone.manuallyAddFile(file, url);
                self.validateDocs.push({
                    file_name:self.dropZonePreviewFiles[i].file_name,
                    extension:self.dropZonePreviewFiles[i].extension
                });
            }
        }
    },
    addUnit (flag) {

        var self = this;

       if ( flag == 'once' && self.loadOnce == true ) {

            return;

       }else{

            self.unitArr.push({
                unit:'',
                date_added: '',
                unit_error_msg:'',
                date_added_error_msg:'',
                disable_select:false,
                isACV:1,
                acv_error_msg:'',
                credit_limit:'',
                credit_limit_error_msg:'',
            });

        self.loadOnce = true;
       }

    },

    removeUnit:function(id){

        var self = this;
        var data = self.idArr;

        if (confirm('Are you sure that you want to delete this Insurance Unit? ')) {
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/remove_mapper_unit",
                type: "POST",
                data: {
                    id:id
                },
                dataType: "json",
                headers: this.ajxHeaders,
                success: function(data) {
                    self.loading=false;

                    if (data.status == "success") {
                        if ( self.urlArr[3] != undefined && self.urlArr[3] != null) {
                            var policyId = self.urlArr[3];
                            self.loadInsurancePolicy(policyId);
                        }
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading=false;

                    self.generateStatusCodeMessage(jqXHR,true,'delete-insurance-policy')
                }
            });
        }
    },

    addLine ($event, index) {

        var self = this;
        self.unitArr[index].unit_error_msg = "";
        self.unitArr[index].date_added_error_msg = "";
        self.unitArr[index].credit_limit_error_msg = "";
        index = self.unitArr.length - 1;

        if (String(self.unitArr[index].credit_limit).includes(',')){
            self.unitArr[index].credit_limit = self.unitArr[index].credit_limit.replace(',','');
        }

        if ( self.unitArr[index].unit_no != null && self.unitArr[index].unit_no.value && self.unitArr[index].date_added != '' && self.unitArr[index].date_added != null && ((self.unitArr[index].isACV == 0 && self.unitArr[index].credit_limit != '') || self.unitArr[index].isACV == 1)) {

            self.unitArr.push({

                unit_no: {text:'',value:''},
                date_added: '',
                date_added_error_msg:'',
                unit_error_msg:'',
                disable_select:false,
                isACV:1,
                acv_error_msg:'',
                credit_limit:'',
                credit_limit_error_msg:''
            })

        } else {

            if ( self.unitArr[index].unit_no == null || !self.unitArr[index].unit_no.value ) {

                self.unitArr[index].unit_error_msg = "Unit Required.";
            }

            if (self.unitArr[index].date_added == null || self.unitArr[index].date_added == "") {

                self.unitArr[index].date_added_error_msg = "Date Added Required.";
            }
            if (self.unitArr[index].isACV == 0){
                if (self.unitArr[index].credit_limit == null || self.unitArr[index].credit_limit == "" || self.unitArr[index].credit_limit < 1) {

                    self.unitArr[index].credit_limit_error_msg = "Credit Limit Required.";
                }
            }

        }

    },
    saveId(evt,id){
        var self = this;
        // alert(id);
        console.log(evt.target.checked);
        if(evt.target.checked == true){
            self.idArr.push({id:id});
        }else{
            var i = self.idArr.indexOf(id);
            const filteredItems = self.idArr.filter(function(item) {
                return item.id !== id
            })
            self.idArr = filteredItems;
        }
    },


    removeLine (ind,id) {

        var self = this;
        // alert(id);
        if(id != undefined){

            self.removeUnit(id);
        }else{
            if (self.unitArr.length < 2) {
                self.loadOnce = false;
            }
            self.unitArr.splice(ind, 1)

        }

        // $.ajax({
        //     url: process.env.ROOT_API + "/remove-insurance-doc",
        //     type: "POST",
        //     data: {
        //         filePath : file,
        //         id: policyId,
        //         flag:flag
        //     },
        //     headers: {
        //         Accept: "application/json",
        //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
        //         "Access-Control-Allow-Headers":
        //             "Origin, Content-Type, Authorization,X-Requested-With",
        //         "Cache-Control": "no-cache"
        //     },
        //     dataType: "json",
        //     success: function (data) {

        //         if (self.insuranceDocExists || self.selfInsuredDocExists){
        //             self.loading = true;
        //         }else{
        //             self.loading = false;
        //         }

        //     },
        //     error: function (jqXHR, exception) {

        //         self.loading = false;
        //         self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-doc')
        //     }
        // });
    },
    getFilePathFromUrl (value) {

        var path = "";
        var src = value.split('/');
        var file_name = src[src.length - 1];
        var orgPath = src[src.length - 2];
        path = orgPath + "/" + file_name;
        return path;

    },
    removeFileFromServer(file, policyId,flag){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/remove-insurance-doc",
            type: "POST",
            data: {
                filePath : file,
                id: policyId,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                if (self.insuranceDocExists || self.selfInsuredDocExists){
                    self.loading = true;
                }else{
                    self.loading = false;
                }

            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-doc')
            }
        });

    },
    selfInsuredSelected: function(e) {
        var self = this;
        self.self_insured_error_msg = "";
        // self.disableSelfInsured = true;
        self.self_insured = e.target.value;
        self.liability = "";
        self.comprehensive = "";
        self.collision = "";
        self.liability_error_msg = "";
        self.comprehensive_error_msg = "";
        self.collision_error_msg = "";
        self.self_insured_for = "";
        self.add_another_policy = false;
        if (self.self_insured == 1) {
            self.selfInsuredDocs = [];
            self.validateSelfInsuredDocs = [];
            self.previewSelfInsuredFiles = [];
            self.self_insured_for_error_msg = "";
            self.self_insured_doc_error_msg = "";
            self.refreshReplacePolicy();
            self.replaceInsurancePolicyArr = [];
            self.selectedReplacePolicyArr = [];
            self.review_date = "";
            self.review_date_error_msg = "";
            self.common_error_msg = "";
        }else{
            if (self.policy_type != "") {
                self.showInsuranceLimit = true;
                // self.disableSelfInsured = true;
                self.self_insured_for = "";
                self.selectedPolicy = self.policy_type.value;
            }else{
                self.selectedPolicy = "";
            }
            self.emptyFormValues();
        }
    },
    onPolicyTypeSelect(event) {
        var self = this;
        if (self.policy_type != "") {
            self.selectedPolicy = self.policy_type.value;
            self.liability = "";
            self.comprehensive = "";
            self.collision = "";
            self.liability_error_msg = "";
            self.comprehensive_error_msg = "";
            self.collision_error_msg = "";
            if (self.self_insured == 1 || self.self_insured == 0) {
                if (self.self_insured == 1) {
                    self.showInsuranceLimit = true;
                }else{
                    self.showInsuranceLimit = true;
                    self.self_insured_for = "";
                }
            }
        }else{
            self.self_insured_for = "";
            self.selectedPolicy = "";
        }
    },
    // approvedByCredit(event,flag) {
    //     var self = this;
    //     var canApprove = false;
    //     if ( (flag == "comprehensive" && self.comprehensive > 2500) || (flag == "collision" && self.collision > 2500) ) {
    //         canApprove = true;
    //     }
    //     if (canApprove) {
    //         if (!self.showApprovePrompt) {
    //             self.showApprovePrompt = true;

    //             if (confirm('This Required Approval from Credit Team ')) {
    //                 self.approved_by_credit = 1;
    //             }

    //         }
    //     }
    // },
    addAnotherPolicy(event) {
        var self = this;
        self.add_another_policy = event.target.checked;
        self.emptyFormValues();
    },
    emptyFormValues() {
        var self = this;
        self.policy_type = "";
        self.policy_type_error_msg = "";
        self.insurance_company_id = "";
        self.insurance_company_error_msg = "";
        self.policy_number = "";
        self.policy_number_error_msg = "";
        self.customer_error_msg = "";
        self.start_date = "";
        self.start_date_error_msg = "";
        self.expiry_date = "";
        self.expiry_date_error_msg = "";
        self.insurance_agency_id = "";
        self.insurance_agency_error_msg = "";
        self.is_rental_blanket = 0;
        self.credit_limit = "";
        self.credit_limit_error_msg = "";
        self.isACV = 0;
        self.acv_error_msg = "";
        self.comment = "";
        self.unitArr = [];
        self.files = [];
        self.validateDocs = [];
        self.insurance_doc_error_msg = "";
        self.dropZonePreviewFiles = [];
        self.showInsuranceLimit = false;
        self.common_error_msg = "";
        self.refreshReplacePolicy();
        self.replaceInsurancePolicyArr = [];
        self.selectedReplacePolicyArr = [];
        self.review_date = "";
        self.review_date_error_msg = "";
        self.is_lease_blanket = 0;
    },
    storeSelfInsuredDoc(file,response) {
        var self = this;
        self.self_insured_doc_error_msg = "";
        self.selfInsuredDocExists = false;
        // var uploadResponse = JSON.parse(response);
        var uploadResponse = response;
        // if (self.$route.params.id > 0 && self.selfInsuredDocs.length > 0) {
        //     self.selfInsuredDocExists = true;
        // }
        //push doc path in files array
        self.selfInsuredDocs.push(uploadResponse.content);
        if (file.type != undefined) {
            var extension = file.type.split("/");
            self.validateSelfInsuredDocs.push({
                file_name:file.name,
                size:file.size,
                extension:extension[1]
            });
        }

        // if (self.selfInsuredDocExists) {
        //     self.self_insured_doc_error_msg = "Existing File will be removed on Update.";
        // }
    },
    removeSelfInsuredFile(file, xhr, error) {
        var self = this;
        var policyId = "";
        self.self_insured_doc_error_msg = "";
        if (file.xhr != undefined) {
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],policyId,"temp");

            for(var i = 0;i<self.selfInsuredDocs.length;i++){
                if ( self.selfInsuredDocs[i].includes(fileName)) {
                    self.selfInsuredDocs.splice(i,1);
                    self.validateSelfInsuredDocs.splice(i,1);
                    self.selfInsuredDocExists = false;
                }
            }
        }
        console.log(self.selfInsuredDocs);

    },
    afterSelfInsuredComplete(file,response){
        var self = this;
    },
    removeSelfInsuredFiles() {
        var self = this;
        self.$refs.insuredDropzone.removeAllFiles();
    },
    //load files in drop zone
    loadSelfInsuredFiles:function() {
        var self = this;
        if ( self.previewSelfInsuredFiles.length > 0 ) {

            for ( var i = 0;i<self.previewSelfInsuredFiles.length;i++ ) {

                var file = { size: self.previewSelfInsuredFiles[i].size, name: self.previewSelfInsuredFiles[i].file_name, type: self.previewSelfInsuredFiles[i].file_type};
                var url = self.previewSelfInsuredFiles[i].url;
                //get file path from url
                self.selfInsuredDocs.push(self.getFilePathFromUrl(self.previewSelfInsuredFiles[i].url));
                self.validateSelfInsuredDocs.push({
                    file_name:self.previewSelfInsuredFiles[i].file_name,
                    extension:self.previewSelfInsuredFiles[i].extension
                });
            }
        }
    },
    onCustomerSelect(event) {
        var self = this;
        self.subAccountsArr = [];
        // self.selectedSubAccounts = [];
        self.customer_error_msg = "";

        // if (self.customer_id != null && self.customer_id != "") {
        //     self.loadSubAccounts(self.customer_id.value,self.customer_id.code);
        // }
        if (self.is_national_lease == 0) {

        }
        //as per new changes
        if (self.customer_id != null && self.customer_id != "") {
            self.addCustomer();
        }
    },
    loadSubAccounts(custId,custCode) {
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/fetch-sub-accounts",
            type: "POST",
            data: {
                id : custId,
                code: custCode,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                if (data.status == "success") {
                    self.subAccountsArr = data.content
                }else{
                    self.subAccountsArr = [];
                    self.selectedSubAccounts = [];
                }

            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'fetch-sub-accounts')
            }
        });
    },
    onSubAccountSelect(event,row,index) {
        var self = this;
        var policyId = 0;
        var path = window.location.pathname;
        var segments = path.split("/");
        if ( segments[3] != undefined ) {
            policyId = segments[3];
        }

        if(event.target.checked == true){
            self.selectedSubAccounts.push({policy_id:policyId,customer_id:row.value,disable_select:false});
        }else{
            var i = self.selectedSubAccounts.indexOf(row);
            const filteredItems = self.selectedSubAccounts.filter(function(item) {
                return item.customer_id !== row.value
            })
            self.selectedSubAccounts = filteredItems;
        }
    },
    fetchReplacePolicy() {
        var self = this;
        var error = false;
        self.customer_error_msg = "";
        self.policy_type_error_msg = "";
        self.start_date_error_msg = "";
        self.expiry_date_error_msg = "";
        self.common_error_msg = "";

        if (self.customer_id == null || !self.customer_id.value) {
            self.customer_error_msg = "Customer is Required.";
            error = true;
        }

        if (self.policy_type == "" || !self.policy_type.value) {
            self.policy_type_error_msg = "Policy Type is Required.";
            error = true;
        }

        if(self.is_rental_blanket == 0){

            if ( !self.unitArr[0] || self.unitArr[0].unit_no == null || !self.unitArr[0].unit_no.value ){

                self.common_error_msg = "Please select the unit for this policy";
                error = true;
                return;
            }else{
                self.unitArr[0].unit_error_msg = "";
            }
            if ( !self.unitArr[0] || self.unitArr[0].date_added == '' ){

                self.common_error_msg = "Please select the date added for the unit";
                error = true;
                return;
            }else{
                self.unitArr[0].date_added_error_msg = "";
            }


            for ( var i = 0; i < self.unitArr.length; i++ ) {

                if ( self.unitArr[i].unit_no == null || !self.unitArr[i].unit_no.value ) {

                    self.unitArr[i].unit_error_msg = "Unit Required.";
                    error = true;

                }else{
                    self.unitArr[i].unit_error_msg = "";
                }

                if (self.unitArr[i].date_added == null || self.unitArr[i].date_added == "") {

                    self.unitArr[i].date_added_error_msg = "Date Added Required.";
                    error = true;

                }else{
                    self.unitArr[i].date_added_error_msg = "";
                }

            }
        }

        if (!error) {
            var customerIdArr = [];
            customerIdArr.push(self.customer_id.value);
            for(var i = 0;i < self.selectedSubAccounts.length;i++) {
                customerIdArr.push(self.selectedSubAccounts[i].customer_id);
            }

            var unitIdArr = [];
            if (self.is_rental_blanket == 0) {
                for ( var i = 0; i < self.unitArr.length; i++ ) {
                    unitIdArr.push(self.unitArr[i].unit_no.value);
                }
            }

            var fields = {
                customer_id:customerIdArr,
                policy_type:self.policy_type.value,
                is_rental_blanket:self.is_rental_blanket,
                start_date:self.start_date,
                expiry_date:self.expiry_date,
                unit_id:unitIdArr
            }

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/insurancepolicy/replace",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (data.status == "success") {

                        if (data.content.length > 0) {
                            self.refreshReplacePolicy();
                            self.replaceInsurancePolicyArr = data.content;
                            self.selectedReplacePolicyArr = [];
                        }else{
                            self.common_error_msg = "No Policy Found.";
                            self.refreshReplacePolicy();
                            self.replaceInsurancePolicyArr = [];
                            self.selectedReplacePolicyArr = [];
                            setTimeout(function () {
                                self.common_error_msg = "";
                            }, 10000);
                        }

                    } else {
                        self.refreshReplacePolicy();
                        self.replaceInsurancePolicyArr = [];
                        self.selectedReplacePolicyArr = [];
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-replace')
                }
            });
        }

    },
    clickRows(evt,row,index){
        var self = this;
        self.common_error_msg = "";
        if(evt.target.checked == true){
            self.selectedReplacePolicyArr.push({id:row.id});
        }else{
            var i = self.selectedReplacePolicyArr.indexOf(row);
            const filteredItems = self.selectedReplacePolicyArr.filter(function(item) {
                return item.id !== row.id
            })
            self.selectedReplacePolicyArr = filteredItems;
        }
    },
    refreshReplacePolicy() {
        var self = this;
        for (var i = 0;i < self.replaceInsurancePolicyArr.length;i++) {
            $("#selectCheckbox" + i). prop("checked", false); //check selected insurance policy
        }
    },
    isNationalLeaseSelected(event) {
        var self = this;
        self.is_national_lease = event.target.value;
        self.customer_error_msg = "";
        self.customerArr = [];
        self.customer_id = "";
        self.selectedSubAccounts = [];
    },
    addCustomer() {
        var self = this;
        var error = false;
        self.customer_error_msg = "";

        /*if (!self.customer_id || self.customer_id == null || self.customer_id == "") {
            self.customer_error_msg = "Customer Required.";
            error = true;
            return;
        }*/

        for(var i = 0;i < self.selectedSubAccounts.length;i++) {
            if (self.selectedSubAccounts[i] != undefined) {
                if (self.selectedSubAccounts[i] != null) {
                    if (self.customer_id != null) {
                        if (self.selectedSubAccounts[i].customer_id == self.customer_id.value) {
                            self.customer_error_msg = "Customer Already Added.";
                            error = true;
                        }
                    }
                }
            }
        }

        if (self.is_national_lease == 0) {
            var customerCode = self.customer_id.code;
            var codeSplit = customerCode.split("-");
            var existingCustomerCode = "";
            for(var i = 0;i < self.selectedSubAccounts.length;i++) {
                if (self.selectedSubAccounts[i] != undefined) {
                    if (self.selectedSubAccounts[i] != null) {
                        if (self.selectedSubAccounts[i].code != null) {
                            existingCustomerCode = self.selectedSubAccounts[i].code;
                        }
                    }
                }
            }

            if (codeSplit != null) {
                if (codeSplit.length <= 3) {
                    if (codeSplit[1] != undefined) {
                        if (codeSplit[1] != null && codeSplit[1] != "") {
                            var checkCustomerCode = codeSplit[1];
                            if (self.selectedSubAccounts.length > 0) {
                                if (!existingCustomerCode.includes(checkCustomerCode)) {
                                    self.customer_error_msg = "Select Customer With Proper Sub Account.";
                                    error = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (!error) {
            var policyId = 0;
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( segments[3] != undefined ) {
                policyId = segments[3];
            }
            self.selectedSubAccounts.push({policy_id:policyId,customer_id:self.customer_id.value,disable_select:false,text:self.customer_id.text,code:self.customer_id.code});
            self.customerArr = [];
            self.customer_id = "";
        }
    },
    removeSelectedCustomer(index,cust) {
        var self = this;
        if (self.selectedSubAccounts[index] != undefined && self.selectedSubAccounts[index] != null) {
            if (self.selectedSubAccounts[index].policy_id == 0) {
                self.selectedSubAccounts.splice(index,1);
            }else{
                if (self.selectedSubAccounts[index].disable_select) {
                    if (self.policy_message != "" && self.policy_message != null) {
                        self.$swal('',self.policy_message,'info');
                        return;
                    }else{
                        self.selectedSubAccounts.splice(index,1);
                    }
                }else{
                    self.selectedSubAccounts.splice(index,1);
                }
            }
        }
    },
    checkLeaseSelected: function(e) {
        var self = this;
        self.is_lease_blanket = e.target.value;
        if(self.is_rental_blanket != 0 && (self.is_lease_blanket == 1 || self.is_lease_blanket == 2)){
            if (self.unitArr.length > 0) {
                self.$swal('','Added scheduled unit will be removed on update','warning');
            }
        }
        self.common_error_msg = "";
    },
    onPolicySelect(event) {
        var self = this;
        if (self.policyown != null && self.policyown.value == 'own'){
            self.disableCustField = true;
            console.log('here');

            $.ajax({
                url: process.env.ROOT_API + "/fetch-vtrl-customer",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (data.status == "success") {
                        self.customer_id = [];
                        self.selectedSubAccounts = [];
                        var selectedAcc = data.content;
                        self.customer_id = {text:selectedAcc.code + " | " + selectedAcc.name,value:selectedAcc.id,code:selectedAcc.code};

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-replace')
                }
            });
        }else{
            self.disableCustField = false;
            self.customer_id = "";
            self.customerArr = [];
            // self.selectedSubAccounts = [];
        }

        //as per new changes
        // if (self.customer_id != null && self.customer_id != "") {
        //     self.addCustomer();
        // }
    },
  }
};
</script>
<style scoped>
.disable-link {
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/insurance/InsurancePolicyForm.vue